import React, { FC, useMemo, useState } from 'react';
import CallOffsList from './CallOffsList';
import CallOffsStart from './CallOffsStart';
import CallOffsEmpty from './CallOffsEmpty';
import { useActiveInboxState, useLoadInboxTotal } from 'src/models/callOffs/hooks';
import {
  SearchCallOffsContext,
  UpdateSearchCallOffsContext,
  INITIAL_CALL_OFFS_SEARCH
} from 'src/models/callOffs/context';
import { Navigate } from 'react-router-dom';
import { useFeatureFlag, FeatureFlag } from 'src/helpers/featureFlag';
import { Paths } from '../paths';
import CallOffsDndLayer from './CallOffsList/DndLayer';
import CallOffsSidebars from './CallOffSidebars';

export const CallOffsPage: FC = () => {
  const [inbox] = useActiveInboxState();
  const { data: callOffsData, loading } = useLoadInboxTotal();
  const callOffs = callOffsData?.getInboxEmails.total;

  const isCallOffFeature = useFeatureFlag(FeatureFlag.Mercury);

  const isEmptyInbox = useMemo(() => {
    return !callOffs && !loading;
  }, [callOffs, loading]);

  const [callOffsSearch, setCallOffsSearch] = useState(INITIAL_CALL_OFFS_SEARCH);

  return (
    <>
      {isCallOffFeature ? (
        <>
          {inbox ? (
            inbox.isArchived ? (
              <Navigate to={Paths.HOME_PATH} />
            ) : isEmptyInbox ? (
              <>
                <CallOffsEmpty />
                <CallOffsSidebars />
              </>
            ) : (
              <UpdateSearchCallOffsContext.Provider value={setCallOffsSearch}>
                <SearchCallOffsContext.Provider value={callOffsSearch}>
                  <CallOffsDndLayer />
                  <CallOffsList key={inbox.emailAddress} />
                  <CallOffsSidebars />
                </SearchCallOffsContext.Provider>
              </UpdateSearchCallOffsContext.Provider>
            )
          ) : (
            <CallOffsStart />
          )}
        </>
      ) : (
        <Navigate to={Paths.PROCUREMENT_TABLE_PAGE} />
      )}
    </>
  );
};

export default CallOffsPage;
